import { Nullable } from '@crossbeam/types';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';

import { ChatErrorCode, useWebSocketStore } from '@/stores/MCPWebsocketStore';

export function useAIChatState() {
  const wsStore = useWebSocketStore();
  const { parsedMessages, chatSessionId, preventPolling } =
    storeToRefs(wsStore);

  const isWaitingOnResponse = ref(false);
  const hasReceivedFirstResponse = ref(false);
  const nextMessage = ref('');

  const receivedMessagesInOrder = ref<
    {
      role: 'user' | 'bot';
      content: string;
      errorCode?: Nullable<ChatErrorCode>;
      messageId?: string;
    }[]
  >([]);
  const currentMessageEndIndex = ref(0);

  const error = ref<Nullable<ChatErrorCode>>(null);

  type MessageFeedback = {
    id: string;
    feedback: 'like' | 'dislike';
  };
  const messagesWithFeedback = ref<MessageFeedback[]>([]);

  return {
    receivedMessagesInOrder,
    currentMessageEndIndex,
    wsStore,
    parsedMessages,
    isWaitingOnResponse,
    nextMessage,
    hasReceivedFirstResponse,
    chatSessionId,
    messagesWithFeedback,
    preventPolling,
    error,
  };
}
